export const downloadCSV = (
  data,
  filename = "ledger_report.csv"
) => {

  if (!data || !data.length) {
    alert("No data available");
    return;
  }

  const headers = Object.keys(data[0]);

  const rows = data.map((item) =>
    headers.map((header) => {

      let value = item[header];

      if (value === null || value === undefined) {
        value = "";
      }

      return `"${String(value).replace(/"/g, '""')}"`;

    }).join(",")
  );

  const csvContent = [
    headers.join(","),
    ...rows
  ].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;"
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");

  link.href = url;

  link.download = filename;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};